import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileState } from '../state/profile.state';
import { Store } from '@ngxs/store';
import { first, tap } from 'rxjs';

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(Store)
    .select(ProfileState.getIsCompanyAdmin)
    .pipe(
      tap((isAdmin) => {
        if (!isAdmin) {
          router.navigateByUrl('/');
        }
      }),
      first(),
    );
};
